import { mandiService } from "./base";

// Digital E-Sign Ledger — the FruitX app talks to mandiservice only.

// Pending statement awaiting the buyer's signature (or null).
export const getPendingLedgerEsign = (customerId) =>
  mandiService.get(`/saleorder/esign_ledger/requests`, {
    params: { customer_id: customerId },
  });

// Previously signed statements (history).
export const getSignedLedgerEsigns = (customerId) =>
  mandiService.get(`/saleorder/esign_ledger/signed`, {
    params: { customer_id: customerId },
  });

// Send the 4-digit OTP to the registered mobile.
// params: { customer_id, phone_number, esign_request_id }
export const sendLedgerEsignOtp = (params) =>
  mandiService.post(`/saleorder/sendledgeresignotp`, params);

// Verify the OTP and record the signature.
// params: {
//   esign_request_id,
//   verify_otp_req: { id, customer_id, otp },
//   signature: { device_id, latitude, longitude, ip_address },
//   phone_number,
// }
export const verifyLedgerEsignOtp = (params) =>
  mandiService.post(`/saleorder/verifyledgeresignotp`, params);
